import { fetch as apiFetch, postData, putData } from "../../Component/function/FunctionApi";

// =========================================================
// Endpoints
// =========================================================

const REPRESENTATIVES_URL = "Represntative/get-Represntatives";
const SETTLEMENT_URL = "RepresentativeSettlement";

// =========================================================
// GET: Representatives
// =========================================================

export const fetchRepresentatives = async () => {
  const response = await apiFetch(REPRESENTATIVES_URL);
  console.log("REPRESENTATIVES RESPONSE:", response);

  const data = response?.data || response || [];
  return Array.isArray(data) ? data : [];
};

// =========================================================
// GET: Summary
// =========================================================

export const fetchSummary = async (representativeId, selectedDate) => {
  const date = `${selectedDate}T00:00:00`;

  const params = new URLSearchParams();
  params.append("representativeId", representativeId);
  params.append("date", date);

  console.log("GET SUMMARY:", `${SETTLEMENT_URL}/summary?${params.toString()}`);

  const response = await apiFetch(`${SETTLEMENT_URL}/summary?${params.toString()}`);
  console.log("SUMMARY RESPONSE:", response);

  const data = response?.data || response;
  return data || null;
};

// =========================================================
// GET: Settlement Records
// =========================================================

export const fetchSettlements = async (representativeId, selectedDate) => {
  const formattedDate = `${selectedDate}T00:00:00`;

  const params = new URLSearchParams();
  params.append("RepresentativeId", representativeId);
  params.append("Date", formattedDate);

  console.log("GET SETTLEMENTS:", `${SETTLEMENT_URL}?${params.toString()}`);

  const response = await apiFetch(`${SETTLEMENT_URL}?${params.toString()}`);
  console.log("SETTLEMENT RECORDS RESPONSE:", response);

  const data = response?.data || response || [];
  return Array.isArray(data) ? data : [];
};

// =========================================================
// POST: Create Settlement
// =========================================================

export const createSettlement = async (payload) => {
  console.log("CREATE SETTLEMENT PAYLOAD:", payload);
  return postData(SETTLEMENT_URL, payload);
};

// =========================================================
// PUT: Update Settlement
// PUT /api/RepresentativeSettlement/{id}
// =========================================================

export const updateSettlement = async (id, payload) => {
  console.log("UPDATE SETTLEMENT:", `${SETTLEMENT_URL}/${id}`, payload);
  return putData(`${SETTLEMENT_URL}/${id}`, payload);
};